import UserBookingDTO from '@src/adapters/dto/user/UserBookingDTO';
import useApi, { ApiOptions } from '../base/useApi';

interface Params {
  dateFrom: Date;
  dateTo: Date;
  productionId: string | undefined;
  jobId: string | undefined;
}

interface Result {
  users: UserBookingDTO[];
}

const options: ApiOptions = {
  method: 'get',
  urlPath: '/user/booking_list/',
  baseUrl: process.env.REACT_APP_API_URL!,
  lazy: false,
};

export const useFindBookingListLazy = (params?: Params) => {
  options.lazy = true;
  return useApi<Params, Result>(options, params);
};

export default useFindBookingListLazy;
